import script from "./VideoEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./VideoEditor.vue?vue&type=script&setup=true&lang=js"

import "./VideoEditor.vue?vue&type=style&index=0&id=3c14fff4&scoped=true&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c14fff4"]])

export default __exports__